// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core'
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart, LineChart, PieChart } from 'echarts/charts'
// 引入颜色模块
import { color } from 'echarts'
// 引入水球图插件
import 'echarts-liquidfill'
// 引入 3D 图表插件
import 'echarts-gl'
// 引入标题，提示框，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent,
  ToolboxComponent,
  DataZoomComponent,
  GeoComponent,
  VisualMapComponent,
  GraphicComponent
} from 'echarts/components'
// 标签自动布局、全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features'
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers'
// 注册必须的组件
echarts.use([
  TitleComponent, // 标题组件
  TooltipComponent, // 提示框组件
  GridComponent, // 直角坐标系组件
  DatasetComponent,
  TransformComponent, // 数据转换器组件
  BarChart, // 柱状图图表
  LabelLayout, // 标签自动布局特性
  UniversalTransition,
  CanvasRenderer, // Canvas 渲染器
  LineChart, // 折线图图表
  PieChart, // 饼图图表
  LegendComponent, // 图例组件
  ToolboxComponent, // 工具箱组件
  DataZoomComponent, // 数据区域缩放组件
  GeoComponent, // 地理坐标系组件
  VisualMapComponent, // 视觉映射组件
  GraphicComponent // 图形组件
])

// 导出 echarts 对象
export default echarts
